import React from "react";
import ServicePageTemplate, { BenefitItem, ProcessItem, WhyChooseItem } from "../Components/service-template/service-template";
import customSoftware from "../Assets/image/services/custom-software-development.webp";
import { Cloud, Shield, CreditCard, Zap, RefreshCw, BarChart, Map, Layout, Settings, Rocket } from "lucide-react";

function CustomSaaSDevelopment() {
  const benefitsList: BenefitItem[] = [
    {
      title: "Multi-Tenant Security",
      description: "Secure data partitioning and tenant-level configurations that ensure client data is isolated, protected, and private.",
    },
    {
      title: "Subscription Billing",
      description: "Seamless integration with Stripe, Chargebee, or custom gateways to manage multi-tiered billing, cycles, and upgrades.",
    },
    {
      title: "Elastic Scalability",
      description: "Cloud-native architectures that auto-scale infrastructure based on real-time traffic demand, optimizing costs.",
    },
    {
      title: "Third-Party Integrations",
      description: "Pre-built connectors to sync your SaaS telemetry seamlessly with popular CRMs, ERPs, and marketing platforms.",
    },
    {
      title: "Real-Time Telemetry",
      description: "Comprehensive administration dashboards that aggregate usage trends, system health, and monthly recurring revenue metrics.",
    },
    {
      title: "Zero-Downtime Deployment",
      description: "Continuous rolling update deployment pipelines that roll out features without interrupting client user workflows.",
    },
  ];

  const processList: ProcessItem[] = [
    {
      step: 1,
      title: "SaaS Strategy & Framing",
      icon: <Map />,
      description: "We define tenant modeling, subscription pricing strategies, and data architecture to fit your business goals.",
    },
    {
      step: 2,
      title: "High-Fidelity Prototyping",
      icon: <Layout />,
      description: "Designing intuitive multi-tenant user portals and comprehensive admin control consoles.",
    },
    {
      step: 3,
      title: "Agile Dev & Auto-Scaling",
      icon: <Settings />,
      description: "Writing robust, scalable APIs and frontends using React, Node.js, and cloud services.",
    },
    {
      step: 4,
      title: "Launch & CI/CD Pipelines",
      icon: <Rocket />,
      description: "Deploying to production with secure automated pipelines, load balancers, and active monitoring.",
    },
  ];

  const whyChooseList: WhyChooseItem[] = [
    {
      id: 1,
      title: "Cloud-Native Infrastructure",
      description: "We design SaaS products to thrive on AWS and Google Cloud with Docker and Kubernetes configurations.",
      icon: <Cloud size={24} />,
    },
    {
      id: 2,
      title: "Enterprise Grade Security",
      description: "Built-in protection against OWASP top threats, complete with SSO, multi-factor login, and encryption.",
      icon: <Shield size={24} />,
    },
    {
      id: 3,
      title: "Recurring Monetization Ready",
      description: "Pre-integrated subscription frameworks, usage-based metering, and invoicing pipelines.",
      icon: <CreditCard size={24} />,
    },
    {
      id: 4,
      title: "Rapid Market Entry",
      description: "We utilize boilerplate architectures and rapid-development frameworks to slash time-to-market.",
      icon: <Zap size={24} />,
    },
    {
      id: 5,
      title: "Continuous Deployment",
      description: "Deploy feature updates, hot-fixes, and adjustments seamlessly without causing client downtime.",
      icon: <RefreshCw size={24} />,
    },
    {
      id: 6,
      title: "Rich Analytics Dashboards",
      description: "Integrated instrumentation tracking usage metrics, user behaviors, and revenue reporting.",
      icon: <BarChart size={24} />,
    },
  ];

  return (
    <ServicePageTemplate
      metaTitle="Custom SaaS Development Services | Softcoding Solutions"
      metaDescription="Build your multi-tenant SaaS application with engineering excellence. Robust cloud architectures, auto-scaling, and secure subscription models."
      canonicalUrl="https://softcodingsolutions.com/custom-saas-development-company"
      heroTitle="Custom SaaS Development"
      heroSubtitle="Transform your product vision into a scalable, secure, and revenue-generating Software-as-a-Service platform."
      heroImage={customSoftware}
      benefitsTitle="benefits of SaaS development"
      benefitsHeading="Empower your business with multi-tenant subscription software built for global performance."
      benefitsList={benefitsList}
      processTitle="our SaaS process"
      processDescription="From concept framing to auto-scaling cloud deployments—engineered for rapid SaaS validation and growth."
      processList={processList}
      processImage={customSoftware}
      whyChooseTitle="Why Softcoding Solutions for SaaS"
      whyChooseList={whyChooseList}
      contactHeading="Let's build SaaS that works for you."
      contactDescription="Contact us today to discuss your product needs, and let's create a powerful, multi-tenant SaaS solution tailored specifically to your business."
      contactPurpose="SaaS Development"
      contactFormTitle="Hire SaaS Developer"
    />
  );
}

export default CustomSaaSDevelopment;
